import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, Events } from 'ionic-angular';
import * as Highcharts from 'highcharts/highcharts';
import * as HighchartsMore from 'highcharts/highcharts-more';
import * as HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import { DataManagementService } from '../../providers/data-management.service';

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
/**
 * Generated class for the DashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
})
export class DashboardPage {
    charged : boolean = false;

    selectedV : any;
    marque : string;
    matricule : string;
    valueSpeed :number=0;
    valueTemp :number=60;
    valueRpm :number=0;
    valueFuel :number=0;
    valueTfu :number=0;
    valueFuelRate :number=0;
    fuelLitreValue :number=0;
    valueAccumOdo :any=0;
  constructor(public navCtrl: NavController, public navParams: NavParams,private menu: MenuController,
    public events: Events,public dataManagementService:DataManagementService) {
    this.selectedV = this.navParams.get('group');
    console.log("selectedV",this.selectedV.vehicule);
    this.marque = this.selectedV.vehicule.mark;
    this.matricule = this.selectedV.vehicule.matricule;
    this.valueSpeed = this.selectedV.vehicule.realTimeRecord.speed;
    
    this.getDashboard(this.selectedV.vehicule);
   
  }

  ionViewDidLoad() {
    var gaugeOptions = {

        chart: {
            type: 'solidgauge'
        },
    
        title: null,
    
        pane: {
            center: ['50%', '85%'],
            size: '100%',
            startAngle: -90,
            endAngle: 90,
            background: {
                backgroundColor:
                (Highcharts.theme && Highcharts.theme.background2)|| '#EEE',
                innerRadius: '60%',
                outerRadius: '100%',
                shape: 'arc'
            }
        },
    
        tooltip: {
            enabled: false
        },
    
        // the value axis
        yAxis: {
            stops: [
                [0.1, '#55BF3B'], // green
                [0.5, '#DDDF0D'], // yellow
                [0.9, '#DF5353'] // red
            ],
            lineWidth: 0,
            minorTickInterval: null,
            tickAmount: 2,
            title: {
                y: -70
            },
            labels: {
                y: 16
            }
        },
    
        plotOptions: {
            solidgauge: {
                dataLabels: {
                    y: 5,
                    borderWidth: 0,
                    useHTML: true
                }
            }
        }
    };

    // The speed gauge
    var chartSpeed = Highcharts.chart('container-speed', Highcharts.merge(gaugeOptions, {
        yAxis: {
            min: 0,
            max: 200,
            title: {
                text: 'Speed'
            }
        },

        credits: {
            enabled: false
        },

        series: [{
            name: 'Speed',
            data: [this.valueSpeed],
            dataLabels: {
                format:
                    '<div style="text-align:center">' +
                    '<span style="font-size:12px">{y}</span><br/>' +
                    '<span style="font-size:10px;">km/h</span>' +
                    '</div>'
            },
            tooltip: {
                valueSuffix: ' km/h'
            }
        }]

    }));

    // The RPM gauge

    var chartRpm= Highcharts.chart('container-rpm', Highcharts.merge(gaugeOptions, {
        yAxis: {
            min: 0,
            max: 8,
            title: {
                text: 'RPM'
            }
        },

        credits: {
            enabled: false
        },

        series: [{
            name: 'RPM',
            data: [this.valueRpm],
            dataLabels: {
                format:
                    '<div style="text-align:center">' +
                    '<span style="font-size:12px">{y}</span><br/>' +
                    '<span style="font-size:8px;">* 1000 / min</span>' +
                    '</span>' +
                    '</div>'
            },
            tooltip: {
                valueSuffix: ' '
            }
        }]

    }));

    // The Temp gauge

    var chartTemp= Highcharts.chart('container-temp', Highcharts.merge(gaugeOptions, {
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: 'Temp'
            }
        },

        credits: {
            enabled: false
        },

        series: [{
            name: 'Temp',
            data: [this.valueTemp],
            dataLabels: {
                format:
                    '<div style="text-align:center">' +
                    '<span style="font-size:12px">{y}</span><br/>' +
                    '<span style="font-size:10px;">°C</span>' +
                    '</div>'
            },
            tooltip: {
                valueSuffix: ' '
            }
        }]

    }));

    // The feul gauge

    var chartFuel= Highcharts.chart('container-fuel', Highcharts.merge(gaugeOptions, {
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: 'Fuel'
            }
        },

        credits: {
            enabled: false
        },

        series: [{
            name: 'Fuel',
            data: [this.valueFuel],
            dataLabels: {
                format:
                    '<div style="text-align:center">' +
                    '<span style="font-size:12px">{y}</span><br/>' +
                    '<span style="font-size:10px;">%</span>' +
                    '</div>'
            },
            tooltip: {
                valueSuffix: ' km/h'
            }
        }]

    }));
  }
  //Get RealTimeRecord data
   getDashboard(vehicule:any) {
    this.valueAccumOdo = this.dataManagementService.getOdoFromRecord(vehicule, vehicule.realTimeRecord.accum_odo);
    console.log('this.valueAccumOdo' ,this.valueAccumOdo);
      console.log(' vehicule' ,  vehicule);
            if (vehicule.device.carb && vehicule.device.opt && vehicule.realTimeRecord) {
                this.valueSpeed = vehicule.realTimeRecord.speed;
                if (vehicule.device.opt.useFms != 0 || vehicule.device.opt.useJ1708 != 0) {
                    if (vehicule.realTimeRecord.ignition) {
                        this.valueTfu = vehicule.realTimeRecord.tfu;
                        //Temp
                        if (vehicule.realTimeRecord.temp_engine >= 60) {
                            this.valueTemp	= vehicule.realTimeRecord.temp_engine;
                        } else {
                            this.valueTemp = 60;
                        }
                        //RPM
                        this.valueRpm = vehicule.realTimeRecord.rpm / 1000;
                        //Fulerate
                        this.valueFuelRate = vehicule.realTimeRecord.fuel_rate;
                        //TFU
                        this.valueTfu = vehicule.realTimeRecord.tfu;
                    }
                    //Fuel FMS
                    
                    if (vehicule.device.carb.max - vehicule.device.carb.min > 0) {
                        if (
                            vehicule.realTimeRecord.fuel >= vehicule.device.carb.min &&
                            vehicule.realTimeRecord.fuel <= vehicule.device.carb.max
                        ) {
                            this.valueFuel =
                                Math.round(
                                    (vehicule.realTimeRecord.fuel - vehicule.device.carb.min) /
                                        (vehicule.device.carb.max - vehicule.device.carb.min)
                                ) * 100;
                            
                            this.fuelLitreValue = this.valueFuel * vehicule.device.carb.volume / 100;
                        }
                    } else {
                        if (
                            vehicule.realTimeRecord.fuel >= vehicule.device.carb.max &&
                            vehicule.realTimeRecord.fuel <= vehicule.device.carb.min
                        ) {
                            this.valueFuel = Math.round(
                                (vehicule.realTimeRecord.fuel - vehicule.device.carb.min) /
                                    (vehicule.device.carb.max - vehicule.device.carb.min) *
                                    100
                            );
                            
                            this.fuelLitreValue = this.valueFuel * vehicule.device.carb.volume / 100;
                        }
                    }
                }
                if (vehicule.device.opt.useFuel) {
                    if (vehicule.realTimeRecord.ignition) {
                        //Anlog Fuel
                        
                        if (vehicule.device.carb.max - vehicule.device.carb.min > 0) {
                            if (
                                vehicule.realTimeRecord.fuel >= vehicule.device.carb.min &&
                                vehicule.realTimeRecord.fuel <= vehicule.device.carb.max
                            ) {
                                this.valueFuel = Math.round(
                                    (vehicule.realTimeRecord.fuel - vehicule.device.carb.min) /
                                        (vehicule.device.carb.max - vehicule.device.carb.min) *
                                        100
                                );
                                this.fuelLitreValue = this.valueFuel * vehicule.device.carb.volume / 100;
                            }
                        } else {
                            if (
                                vehicule.realTimeRecord.fuel >= vehicule.device.carb.max &&
                                vehicule.realTimeRecord.fuel <= vehicule.device.carb.min
                            ) {
                                this.valueFuel = Math.round(
                                    (vehicule.realTimeRecord.fuel - vehicule.device.carb.min) /
                                        (vehicule.device.carb.max - vehicule.device.carb.min) *
                                        100
                                );
                               
                                this.fuelLitreValue = this.valueFuel * vehicule.device.carb.volume / 100;
                            }
                        }
                    }
                }
            }
    
            console.log('========== dashboard values ===========');
            console.log('rpm : ' + this.valueRpm);
            console.log('speed : ' + this.valueSpeed);
            console.log('fuel : ' + this.valueFuel);
            console.log('temp : ' + this.valueTemp);
        }  
   // open menu
   openmenu() {
    
    if (!this.charged){
      
      this.chargingGroupInfoInSideBar();
      this.charged = true;
    }
    this.menu.open();
  }

  chargingGroupInfoInSideBar(){
    this.events.publish("chargingGroupInfo");
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts